import { render, staticRenderFns } from "./modalPublishPolicy.vue?vue&type=template&id=7d260cf6"
import script from "./modalPublishPolicy.vue?vue&type=script&lang=js"
export * from "./modalPublishPolicy.vue?vue&type=script&lang=js"
import style0 from "./modalPublishPolicy.vue?vue&type=style&index=0&id=7d260cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports